import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { TransactionResult } from '../../../../../@core/data/transaction-result';
import { MessageManagementService } from '../../../../../@core/services/message-management.service';
import { RestCallService } from '../../../../../@core/services/rest-call.service';

@Component({
  selector: 'ngx-changepassword-dialog',
  templateUrl: 'change-password.component.html',
  styleUrls: [ 'change-password.component.scss'],
})
export class ChangePasswordDialogComponent {
  formData: FormGroup;

  @Input() title: string;

  constructor(
    protected ref: NbDialogRef<ChangePasswordDialogComponent>,
    private formBuilder: FormBuilder,
    private restService: RestCallService,
    private messageService: MessageManagementService) {
    this.formData = this.formBuilder.group({
      id: [0],
      lastPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      enabled: [true]
    });
  }

  dismiss() {
    this.ref.close();
  }

  save() {
    if (this.formData.valid) {
      this.restService.put("User/ChangePassword", this.formData.value).subscribe(
        (result: TransactionResult<boolean>) => {
          this.messageService.showMessage(result, true);
          this.ref.close();
        },
        (error: any) => {
          this.messageService.error('Error Genérico, reportalo a proveedor', [error.message])
        }
      );
    }
    else

      ;
  }
}
